import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AbstractBuyerComponent } from "../abstract/buyer.component";
import { Pair } from "../../obj/Pair";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { ValidationService } from "../../service/validation.service";
import { Account } from "../../entity/Account";
import { LoadZone } from "../../entity/LoadZone";
import { RateClass } from "../../entity/RateClass";

@Component({
    selector: "kilowant-accounts-listing",
    templateUrl: "../../../html/incs/accounts-listing.html"
})
export class AccountsListingComponent extends AbstractBuyerComponent {
    @Input("accounts") accounts: Account[];
    data: Pair[] = [];

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        public validationService: ValidationService,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
      this.data = [];
      let utility = this.accounts[0].utility;
      let loadZones: LoadZone[] = this._getLoadZones(this.accounts);
      let rateClasses: RateClass[] = this._getRateClasses(this.accounts);
      for (let x = 0; x<loadZones.length; x++) {
         for (let y = 0; y<rateClasses.length; y++) {
              let first = true;
              for(var z = 0; z<this.accounts.length; z++) {
                 if (this.accounts[z].utility!=null && this.accounts[z].loadZone!=null && this.accounts[z].rateClass!=null) {
                    if (  ((<LoadZone>this.accounts[z].loadZone).id==loadZones[x].id) && 
                          ((<RateClass>this.accounts[z].rateClass).id==rateClasses[y].id) ) {
                        if (first) {
                           this.data.push(new Pair(((utility!=null)?utility.name:"-")+" > "+(<LoadZone>loadZones[x]).name+" > "+(<RateClass>rateClasses[y]).name, []));
                        }
                        this.data[this.data.length-1].value.push(Account.accountIdent(this.accounts[z]));
                        first = false;
                    }
                 }
              }                              
         }
      }      
    }
}
